<template>
    <div class="card">
    <div class="card-content">
      <b-table :data="listBeds" :narrowed="true" :hoverable="true" :loading="isLoading" paginated per-page="10">   
        <b-table-column field="n_cama" label="N° de Cama" v-slot="props" searchable>
          Cama {{ props.row.n_cama }}
        </b-table-column>     
        <b-table-column field="state" label="Estado" v-slot="props" searchable>
          {{ props.row.state }}
        </b-table-column>    
        <b-table-column field="ventilator" label="Ventilador" v-slot="props" searchable>
          {{ props.row.ventilator == null ? 'NO' : props.row.ventilator.toUpperCase() }}
        </b-table-column>  
        <b-table-column field="stablishment.name" label="Establecimiento" v-slot="props" searchable>
          {{ props.row.stablishment.name }}
        </b-table-column>     
        <b-table-column field="subcategorization.name" label="Subcategorización" v-slot="props" searchable>
          {{ props.row.subcategorization.name }}
        </b-table-column>     
        <b-table-column field="action" label="Acciones" v-slot="props">
          <button-edit-bed :bed="props.row" :manteiner="true" :changeVentilator="true"></button-edit-bed>
        </b-table-column>
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="frown-open" size="is-large"></b-icon>
              </p>
              <p>No hay camas en el listado actual</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { GetAllBeds } from '../../../services/beds'
import {eventBus} from '../../../main';
import ButtonEditBed from '../../beds/ButtonEditBed.vue';
export default {
  components: { ButtonEditBed },
    data(){
        return{
            listBeds:[],
            isLoading:false
        }
    },
    mounted(){
        this.chargeData();
        eventBus.$on('rechargeTableManteinerBeds',()=>{
          this.chargeData();
        })
    },
    methods:{
        async chargeData(){
            this.isLoading=true;
            this.listBeds=await GetAllBeds(this.$http);
            this.isLoading=false;
        }
    }
}
</script>